<template>
  <svg
    fill="#000000"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="800px"
    height="800px"
    viewBox="0 0 355.694 355.694"
    xml:space="preserve"
  >
    <g>
      <g>
        <g>
          <path
            d="M345.923,287.653l-55.22-55.25c-4.3-4.293-10.299-6.652-16.874-6.652c-6.924,0-13.606,2.695-18.326,7.416l-29.844,29.855
				l-8.077-4.479c-17.75-9.849-42.045-23.329-67.716-49.035c-25.772-25.737-39.268-50.099-49.137-67.912l-4.414-7.839l29.901-29.897
				c9.893-9.917,10.232-25.707,0.75-35.212L71.732,13.421c-4.305-4.29-10.289-6.659-16.855-6.659
				c-6.929,0-13.607,2.708-18.324,7.443L22.982,27.848l-1.279,2.083c-5.041,6.476-9.175,13.757-12.274,21.683
				c-2.87,7.563-4.66,14.745-5.476,21.945c-7.116,59.195,20.173,113.527,94.218,187.559c87.77,87.748,161.109,94.576,181.495,94.576
				c3.482,0,5.603-0.187,6.197-0.252c7.529-0.907,14.735-2.721,22.014-5.543c7.848-3.062,15.102-7.17,21.557-12.214l3.087-2.426
				l12.688-12.454C355.086,312.916,355.41,297.142,345.923,287.653z"
          />
        </g>
        <g>
          <path
            d="M226.283,155.849c2.246,2.252,4.51,3.408,6.726,3.432c1.711,0.018,3.326-0.646,4.569-1.895
				c0.312-0.318,0.528-0.594,0.696-0.816l69.896-69.89l21.119,21.109c4.594,4.594,7.619,2.564,8.707,1.462
				c2.396-2.39,2.449-7.371,2.396-8.497l8.545-90.469c0.023-0.462,0.282-4.611-2.456-7.569C345.347,1.469,343.257,0,339.696,0
				c-9.771,0.006-87.832,10.968-90.757,11.406c-0.931,0-5.74,0.111-8.196,2.57c-1.531,1.537-3.309,4.93,2.102,10.331l19.348,19.354
				l-69.188,69.175c-1.682,1.693-3.675,6.059,0.811,10.553L226.283,155.849z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "OutGoingCall"
}
</script>